import { Component, Input, Output, ViewChild, EventEmitter, ComponentFactoryResolver, OnChanges } from '@angular/core'
import { Screen } from '../../../data/models'
import { ScreenComponentResolver } from './screen-component-resolver'
import { ScreenDirective } from './screen'
import { ExamState } from '../../../core/services';

@Component({
  selector: 'mp-exam-screen',
  templateUrl: './exam-screen.html',
  styleUrls: ['./exam-screen.scss']
})
export class ExamScreenComponent implements OnChanges {
  @Input() public screen: Screen
  @Output() public onUiChangesRequested: EventEmitter<any> = new EventEmitter<any>()
  @ViewChild(ScreenDirective)
  public screenHost: ScreenDirective

  public constructor(
    private _componentFactoryResolver: ComponentFactoryResolver,
    private _screenComponentResolver: ScreenComponentResolver,
    private _examState: ExamState
  ) {}

  public ngOnChanges() {
    this._loadScreenComponent()
  }

  private _loadScreenComponent() {
    const screenFactoryConfigs = this._screenComponentResolver.getComponentClass(this.screen)
    const componentFactory = this._componentFactoryResolver.resolveComponentFactory(screenFactoryConfigs.component)
    const viewContainerRef = this.screenHost.viewContainerRef

    viewContainerRef.clear()

    const screenComponent = viewContainerRef.createComponent(componentFactory).instance
    screenFactoryConfigs.initStrategy(screenComponent, { screen: this.screen, execution: this._examState.testExecution })
    screenComponent.onUiChangesRequested.subscribe((data) => {
      this.onUiChangesRequested.emit(data)
    })
    return screenComponent
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/exam-screen/exam-screen.component.ts